import React from "react";
import autoBind from "react-autobind";
import InternalEvent from "../core/constants/internalEvent.js";
import InternalEventBus from "../core/utils/internalEventBus.js";

export default class BaseComponent extends React.Component {
  // store all subscription tokens
  constructor(props) {
    super(props);
    autoBind(this);
    this.subscriptions = [];
  }

  subscribe(event, handler) {
    let token = InternalEventBus.subscribe(event, handler);
    this.subscriptions.push(token);
  }

  publish(event, payload) {
    InternalEventBus.publish(event, payload);
  }

  unsubscribe(token) {
    let tokenIndex = this.subscriptions.indexOf(token);
    if (tokenIndex !== -1) {
      this.subscriptions.splice(tokenIndex, 1);
    } else {
      throw "Subscription Not Found.";
    }
  }

  showPreloader() {
    this.publish(InternalEvent.App.SHOW_PRELOADER);
  }

  hidePreloader(delay = 150) {
    setTimeout(() => {
      this.publish(InternalEvent.App.HIDE_PRELOADER);
    }, delay);
  }

  copyState() {
    return this.state != null ? JSON.parse(JSON.stringify(this.state)) : undefined;
  }

  deepCopy(obj) {
    if (obj) {
      return JSON.parse(JSON.stringify(obj));
    }
    return null;
  }

  unsubscribeAll() {
    this.subscriptions.map(token => {
      InternalEventBus.unsubscribe(token);
    });
    this.subscriptions = [];
  }
}




// WEBPACK FOOTER //
// ./src/components/baseComponent.js